// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function startGoogleLogin() {
  const redirectUrl = window.location.origin + "/auth-callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function GoogleButton({ label = "Continua con Google", className = "", testid = "google-login-btn" }) {
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={startGoogleLogin}
      className={`inline-flex items-center justify-center gap-3 w-full px-6 py-3.5 bg-white border border-[#323C36] text-[#2A3229] text-sm font-semibold transition-all hover:bg-[#2A3229] hover:text-[#F6F3EF] ${className}`}
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path fill="#EA4335" d="M12 10.2v3.9h5.44c-.24 1.44-1.65 4.22-5.44 4.22-3.27 0-5.94-2.71-5.94-6.06s2.67-6.06 5.94-6.06c1.86 0 3.11.79 3.82 1.47l2.61-2.52C16.79 3.4 14.6 2.4 12 2.4 6.68 2.4 2.4 6.68 2.4 12S6.68 21.6 12 21.6c6.93 0 9.6-4.86 9.6-9.36 0-.63-.06-1.11-.15-1.62H12z"/>
        <path fill="#34A853" d="M3.88 7.35l3.19 2.34C7.9 7.83 9.79 6.44 12 6.44c1.86 0 3.11.79 3.82 1.47l2.61-2.52C16.79 3.83 14.6 2.83 12 2.83 8.06 2.83 4.64 5.06 3.88 7.35z" opacity="0"/>
      </svg>
      <span>{label}</span>
    </button>
  );
}
